'use client';

import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { CaretDown } from 'phosphor-icons';
import * as React from 'react';
import { c } from '../../../utils/tailwind-merge';

function CollapsiblePanelLite({
  className = '',
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Root>) {
  return (
    <AccordionPrimitive.Root className={c('w-full', className)} {...props} />
  );
}

function CollapsiblePanelItemLite({
  className = '',
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Item>) {
  return (
    <AccordionPrimitive.Item
      className={c('flex flex-col', className)}
      {...props}
    />
  );
}

function CollapsiblePanelTriggerLite({
  children,
  className = '',
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Trigger>) {
  return (
    <AccordionPrimitive.Header className="block">
      <AccordionPrimitive.Trigger
        className={c(
          'group flex w-full justify-between gap-2',
          'text-sm font-medium text-content-muted hover:text-link', // <-- texto azul en hover
          'focus-outline mt-2 outline-none transition-all',
          className
        )}
        {...props}
      >
        <div>{children}</div>
        <CaretDown
          size={16}
          className={c(
            'transition-transform duration-300',
            'group-data-[state=open]:rotate-180',
            'text-grey-500 dark:text-content-subtle',
            'group-hover:text-link dark:group-hover:text-link'
          )}
        />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
}

function CollapsiblePanelContentLite({
  className = '',
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Content>) {
  return (
    <AccordionPrimitive.Content
      className="overflow-hidden data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown"
      {...props}
    >
      <div className={className}>{children}</div>
    </AccordionPrimitive.Content>
  );
}

export {
  CollapsiblePanelContentLite,
  CollapsiblePanelItemLite,
  CollapsiblePanelLite,
  CollapsiblePanelTriggerLite,
};
